import { DarwinButton } from 'components/darwin-ui';
import { useTranslation } from 'react-i18next';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import styles from './index.module.css';
import { PolygonSchema } from 'types/maps';
import { Location } from 'types/organizationTypes';
import { formatDate } from 'components/darwin-ui/ListView/helpers';
import {
  exportToGeoJSON,
  getGeoJSONFileName,
} from 'utils/geolocation/geoExporters';
import { downloadBlob } from 'api/apiClient';

interface ExportButtonProps {
  disabled?: boolean;
  location?: Location;
  polygons?: PolygonSchema[];
}

export const ExportButton = ({
  disabled = false,
  location,
  polygons = [],
}: ExportButtonProps) => {
  const { t } = useTranslation();
  const { openNotification } = useFloatNotification();

  const handleExport = () => {
    if (!location) return;

    try {
      // Generate file name
      const locationName = location.name;
      const processName = location.process.name;
      const actualDate = formatDate(new Date().toISOString());
      const baseName = `${locationName} - ${processName} - ${actualDate}`;
      const fileName = getGeoJSONFileName(baseName);

      // Generate GeoJSON blob
      const blob = exportToGeoJSON(polygons);

      // Download the file
      downloadBlob(blob, fileName);

      openNotification(
        t('geolocation.modal.export.success'),
        t('geolocation.modal.export.success-description', {
          count: polygons.length,
        }),
        'success'
      );
    } catch (error) {
      openNotification(
        t('geolocation.modal.export.error'),
        t('geolocation.modal.export.error-description'),
        'error'
      );
    }
  };

  return (
    <DarwinButton
      onClick={handleExport}
      disabled={disabled}
      className={styles.exportButton}
    >
      {t('geolocation.modal.export.button')}
    </DarwinButton>
  );
};
